module.exports = __webpack_public_path__ + "static/img/Healthy Aging@2x.0b62defd.png";